export default __webpack_public_path__ + "fonts/icomoon.14db6b774daa926723d25f857dcb77c6.ttf";